export const getAppCategoryI18nKey = category => {
  return `marketplace-ui-apps-core.groupTags.category.${category}`;
};
export const getCategoryFeatureI18nKey = (category, feature) => {
  return `marketplace-ui-apps-core.categoryFeature.${category}.${feature}`;
};
export const getDataSyncsDataI18nKey = data => {
  return `marketplace-ui-apps-core.dataSyncs.data.${data}`;
};
export const getDataSyncsSyncI18nKey = sync => {
  return `marketplace-ui-apps-core.dataSyncs.sync.${sync}`;
};
export const getSuperCategoryI18nKey = superCategory => {
  return `marketplace-ui-apps-core.groupTags.superCategory.${superCategory}`;
};